import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Typography, Paper } from '@mui/material';
import { ScreenFrame, ViewToggle } from '../PrototypeShared';

export default function ProductionPlanningScreen() {
  const [view, setView] = useState('week'); // week | day | tentative

  return (
    <ScreenFrame
      title="Production planning"
      actions={
        <>
          <ViewToggle value={view} onChange={setView} options={[{ value: 'week', label: 'Week' }, { value: 'day', label: 'Day' }, { value: 'tentative', label: 'Tentative' }]} />
          <Button component={Link} to="/prototype/production-orders" variant="outlined" size="small">Orders list</Button>
          <Button component={Link} to="/prototype/production-orders/new" variant="contained" size="small">New order</Button>
        </>
      }
    >
      <Typography color="text.secondary" paragraph>
        Calendar view: {view}. Toggle between confirmed and tentative planning. Each slot is clickable to edit order.
      </Typography>
      <Paper sx={{ p: 3, minHeight: 300 }}>
        <Typography variant="body2" color="text.secondary">Mon 10 — Demo Product A (Confirmed)</Typography>
        <Typography variant="body2" color="text.secondary">Tue 11 — Demo Product B (Tentative)</Typography>
        <Box sx={{ mt: 2 }}>
          <Button component={Link} to="/prototype/production-orders/PO-001/edit" variant="outlined" size="small">Edit Mon order</Button>
        </Box>
      </Paper>
    </ScreenFrame>
  );
}
